import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { EventqButton } from '../../primitives/button/button';
import {
  EventqSearchableList,
  type EventqSearchableListColumn,
  type EventqSearchableListRow,
  type EventqSearchableListRowAction,
} from '../searchable-list/searchable-list';

export interface EventqCameraListItem {
  id: string;
  label: string;
}

const CAMERA_COLUMNS: EventqSearchableListColumn[] = [
  { key: 'label', style: 'primary' },
  { key: 'toggle', type: 'action' },
];

@Component({
  selector: 'eventq-camera-list-panel',
  imports: [EventqButton, EventqSearchableList],
  templateUrl: './camera-list-panel.html',
  styleUrl: './camera-list-panel.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqCameraListPanel {
  readonly items = input.required<readonly EventqCameraListItem[]>();
  readonly openIds = input.required<readonly string[]>();
  readonly searchQuery = input('');
  readonly searchPlaceholder = input('Search Camera Name');

  readonly searchQueryChange = output<string>();
  readonly toggleCamera = output<string>();
  readonly openAll = output<void>();

  readonly cameraColumns = CAMERA_COLUMNS;

  readonly cameraRows = computed<EventqSearchableListRow[]>(() =>
    this.items().map((item) => {
      const open = this.openIds().includes(item.id);
      return {
        id: item.id,
        label: item.label,
        actionIcon: open ? 'remove_circle' : 'add_circle',
        actionLabel: open ? `Remove ${item.label}` : `Add ${item.label}`,
        actionActive: open,
      };
    }),
  );

  onRowAction(event: EventqSearchableListRowAction): void {
    this.toggleCamera.emit(event.id);
  }
}
